import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  { product: 'Streaming 24/7', detail: '12 spots diarios de 20 segundos' },
  { product: 'Punto de Fe con Margarita', detail: '3 menciones semanales integradas' },
  { product: 'TNO Digest', detail: '2 reseñas SEO + 1 artículo comparativo con enlaces a reserva' },
  { product: 'On-Demand', detail: 'Cápsulas visuales tipo Tour' },
  { product: 'Presencia Web', detail: 'Banner de aliado en portal principal TNO' },
  {
    product: 'Redes Sociales, UGC y Colaboraciones',
    detail: 'Publicidad tipo UGC + colaboraciones del ecosistema TNO + difusión en redes con CTAs',
  },
];

const InvestmentSummary = () => {
  const theme = useTheme();
  const oliveColor = theme.palette.brand?.altamiraOlive || '#2B3A1D';

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Resumen
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Resumen de Inversión
        </Box>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 900, mx: 'auto', borderRadius: 2, borderTop: `5px solid ${oliveColor}` }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Producto</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Detalle</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.primary.light }}>
              <TableCell sx={{ fontWeight: 700, color: 'white' }}>
                INVERSIÓN MENSUAL TOTAL
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 700, color: 'white' }}>
                $390
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;
